import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_FAILURE
} from '../constants'

export function* getLocationsDataMasterSaga({data:{branchOfficeId}}) {
  try {

    if(branchOfficeId){
      const queryString = `?branch_office_id=${branchOfficeId}` 
      const result =  yield call(BFFAgent.Datamasters.getLocations, queryString)
      const locationsList = result?.data?.data

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_SUCCESS,
          data: locationsList
      })

    } else {

      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_FAILURE,
        data: { error: 'Se necesita el Id de la sucursal' }
      })
      
    }
      
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
